import { Button, Input, Modal, notification } from '@pankod/refine-antd';
import { useInput } from 'hooks';
import { useState } from 'react';
import { deleteOrganization } from 'services/organization';
import useOrganizationStore from 'store/useOrganizationStore';

interface OrgDeleteModalProps {
  orgId: string;
  isModalOpen: boolean;
  closeModal: () => void;
}

export const OrgDeleteModal: React.FC<OrgDeleteModalProps> = ({
  orgId,
  isModalOpen,
  closeModal,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const nameInput = useInput('');
  const { organizations, removeOrganization } = useOrganizationStore();

  const selectedOrg = organizations.find((org) => org.id === orgId);
  const isDeleteButtonDisable = selectedOrg?.name !== nameInput.value;

  const handleClose = () => {
    nameInput.reset();
    closeModal();
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await deleteOrganization(orgId);
      removeOrganization(orgId);
    } catch (err: any) {
      console.error(err);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }
    setIsLoading(false);

    closeModal();
  };

  return (
    <Modal
      title="Delete Setup"
      visible={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>
          Keep
        </Button>,
        <Button
          danger
          key="submit"
          type="primary"
          loading={isLoading}
          disabled={isDeleteButtonDisable}
          onClick={handleSubmit}
        >
          Delete
        </Button>,
      ]}
    >
      <>
        <p style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '1rem', userSelect: 'none' }}>
          Confirm deletion of {selectedOrg?.name}
        </p>
        <p>Type the setup name</p>
        <Input
          placeholder={selectedOrg?.name}
          value={nameInput.value}
          onChange={nameInput.onChange}
        />
      </>
    </Modal>
  );
};
